{
  "actions": "Darbības",
  "actionsAvailable": "Pieejamas darbības.",
  "clearSelection": "Notīrīt atlasi",
  "selected": "{count, plural, =0 {Nav atlasīts nekas} other {Atlasīts: #}}",
  "selectedAll": "Atlasīts viss"
}
